/* esm.sh - applesauce-relay@5.2.0/relay */
export * from "/*applesauce-relay@5.2.0/esnext/relay.mjs";
